import styles from './ContactPage.module.scss';

//import React from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector, connect } from 'react-redux';
import React, { useState, useEffect } from 'react';
import LoadingIndicator from '../components/loading-indicator/LoadingIndicator';
import MainNav from '../components/main-nav/MainNav';
import hdrlogo from 'assets/images/hrd-logo.png';
import { ProfileBar } from 'views/components/profile-bar/ProfileBar';
import Label from './../../constants/Label';
import { commonActions } from '../../stores/_actions';

function ContactPage() {
  const profile = JSON.parse(localStorage.getItem('userProfile'));
  const sessionId = JSON.parse(localStorage.getItem('SessionId'));

  const dispatch = useDispatch();
  const [firstName, setfirstName] = useState('');
  const [firstNameErr, setfirstNameErr] = useState({});
  const [lastName, setlastName] = useState('');
  const [lastNameErr, setlastNameErr] = useState({});
  const [mailName, setmailName] = useState('');
  const [mailNameErr, setmailNameErr] = useState({});
  const [number, setnumber] = useState('');
  const [numberErr, setnumberErr] = useState({});
  const [message, setmessage] = useState('');
  const [messageErr, setmessageErr] = useState({});

  const onSubmit = (e) => {
    e.preventDefault();
    const isValid = formValidation();
  };

  const formValidation = () => {
    const firstNameErr = {};
    const lastNameErr = {};
    const mailNameErr = {};
    const numberErr = {};
    const messageErr = {};
    let isValid = true;

    if (!firstName) {
      firstNameErr.firstNameShort = 'First Name is required ';
      isValid = false;
    } else if (firstName.trim().length < 3) {
      firstNameErr.firstNameShort = 'First Name minimum length is 3 char ';
      isValid = false;
    }
    if (lastName.trim().length < 1) {
      lastNameErr.lastNameShort = 'Last Name is required ';
      isValid = false;
    }
    if (mailName.trim().length < 5) {
      mailNameErr.mailNameErrShort = 'Email is required  ';
      isValid = false;
    }
    if (number.trim().length < 5) {
      numberErr.numberShort = 'Mobile Number is required ';
      isValid = false;
    }
    if (number.includes('^([0|+[0-9]{1,5})?([7-9][0-9]{9})$')) {
      numberErr.numberShort = 'Number invalid ';
      isValid = false;
    }
    if (!mailName) {
      mailNameErr.mailNameErrShort = 'Email is required';
      isValid = false;
    } else if (!mailName.includes('@')) {
      mailNameErr.mailNameErrShort = 'Please enter a valid email';
      isValid = false;
    }
    if (!message) {
      messageErr.messageShort = 'Message is required ';
      isValid = false;
    } else if (message.trim().length < 5) {
      messageErr.messageShort = 'Message text minimum length is 5 char ';
      isValid = false;
    }

    setfirstNameErr(firstNameErr);
    setlastNameErr(lastNameErr);
    setmailNameErr(mailNameErr);
    setnumberErr(numberErr);
    setmessageErr(messageErr);
    return isValid;
  };

  useEffect(() => {
    dispatch(commonActions.getCustDetailsByCode(payload));
  }, []);
  const [payload, setPayload] = useState({
    Id: null,
    Message: null,
    CustomerCode: null,
    Status: false,
    SessionID: sessionId,
    IdType: null,
    langcode: '0001',
    Data: {
      CustomerCode: profile?.CustomerCode,
    },
  });
  const userProfile = useSelector((state) => state.getCustDetails.data);
  return (
    <LoadingIndicator>
      <div className={styles.mainContainer}>
        <MainNav />
        <div className={styles.mainContainer__contentPart}>
          <ProfileBar profile={userProfile} />
          <div className={styles.mainContainer__pageCont}>
            <div className={styles.pageLeft}>
              <h1> {Label.ContactUs.heading}</h1>
              <div className={styles.pageLeft__contactList}>
                <div className={styles.pageLeft__item}>
                  <h4>{Label.ContactUs.heading1}</h4>
                  <p>
                    <span>Hamad A.S. Al Ateeqi Building , Al- Mirqaab</span>
                    <span>P.O. Box. 25965, Safat 13120, Kuwait</span>
                  </p>
                </div>
                <div className={styles.pageLeft__item + ' ' + styles.pageLeft__small}>
                  <h4>PHONE</h4>
                  <p>
                    <span>+965-66625914 /22422699 / 22422740</span>
                    {/* <span>
                      Sri. Mahmudul Hoque , Manager<span>Mob : 3058 5442</span>
                    </span> */}
                  </p>
                </div>
                <div className={styles.pageLeft__item + ' ' + styles.pageLeft__small}>
                  <h4>Fax</h4>
                  <p>
                    <span>+965-22405815 </span>
                  </p>
                </div>
                <div className={styles.pageLeft__item} style={{ gridRow: 'span 0' }}>
                  <h4>EMAIL</h4>
                  <p>
                    <span>info@kuwaitindia.com.kw</span>
                  </p>
                </div>
              </div>
            </div>
            <div className={styles.pageRight}>
              <div className={styles.pageRight__getIntoudh}>
                <h2> {Label.ContactUs.heading3}</h2>
                <form onSubmit={onSubmit}>
                  <input
                    type="text"
                    placeholder="First Name"
                    value={firstName}
                    onChange={(e) => {
                      setfirstName(e.target.value);
                    }}
                  />
                  {Object.keys(firstNameErr).map((key) => {
                    return <div className={styles.formgroup__error}>{firstNameErr[key]}</div>;
                  })}
                  <input
                    type="Last Name"
                    placeholder="Last Name"
                    type="text"
                    onChange={(e) => {
                      setlastName(e.target.value);
                    }}
                  />
                  {Object.keys(lastNameErr).map((key) => {
                    return <div className={styles.formgroup__error}>{lastNameErr[key]}</div>;
                  })}
                  <input
                    type="text"
                    placeholder="Email"
                    onChange={(e) => {
                      setmailName(e.target.value);
                    }}
                  />
                  {Object.keys(mailNameErr).map((key) => {
                    return <div className={styles.formgroup__error}>{mailNameErr[key]}</div>;
                  })}
                  <input
                    type="text"
                    placeholder="Mobile Number"
                    onChange={(e) => {
                      setnumber(e.target.value);
                    }}
                  />
                  {Object.keys(numberErr).map((key) => {
                    return <div className={styles.formgroup__error}>{numberErr[key]}</div>;
                  })}
                  <textarea
                    placeholder="Message"
                    onChange={(e) => {
                      setmessage(e.target.value);
                    }}
                  />
                  {Object.keys(messageErr).map((key) => {
                    return <div className={styles.formgroup__error}>{messageErr[key]}</div>;
                  })}

                  <button type="submit" value="Submit" className={styles.linkButton}>
                    {' '}
                    {Label.ContactUs.buttonLabel}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </LoadingIndicator>
  );
}

export { ContactPage };
